import { toast } from "react-toastify";
// import request from "./services";
import instance from "./axiosInstance";
import notify from "utils/notifications";
import axios from "axios";
import http from "./axiosInstance";
import { replace, push } from "connected-react-router";

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export async function refreshToken() {
  try {
    const refreshTokenValue = localStorage.getItem("refresh-token");
    if (!refreshTokenValue) {
      localStorage.removeItem("employee-data");
      localStorage.removeItem("refresh-token");
      localStorage.removeItem("token");
      sessionStorage.clear();
      window.location.reload()
    }

    // axios.defaults.headers
    const tokenRes = await axios.get(
      `${process.env.REACT_APP_AUTH_SERVER_URL}sandbox/internal/auth/rest/v1/oauth/clients/${process.env.REACT_APP_CLIENT_ID}/refresh-token`,
      {
        headers: {
          Authorization: `Bearer ${refreshTokenValue}`
        }
      }
    );
    if (tokenRes.status === 200 && tokenRes.data.status === "success") {
      const {
        data: {
          data: { token }
        }
      } = { ...tokenRes };
      localStorage.setItem("token", token);
      toast.dismiss(); // Close the toast after successful refresh
      window.location.reload();
      return true;
    } else {
      throw new Error("Token refresh failed");
    }
  } catch (err) {
    const newErr = err;
    if (err.response.status === 500) {
      window.location.replace("/error?message=internal_error");
    }
    window.location.replace("/error?message=Session%20expired");
    localStorage.removeItem("employee-data");
    localStorage.removeItem("refresh-token");
    localStorage.removeItem("token");
    sessionStorage.clear();
    return false;
  }
}

export async function handling500ErrorCode(originalRequest, maxRetries) {
  const attempt = (originalRequest._attempt || 0) + 1;
  originalRequest._attempt = attempt;
  try {
    const response = await instance(originalRequest);
    return response;
  } catch (err) {
    await sleep(1000, originalRequest._attempt, maxRetries); // Wait before retrying
    return handling500ErrorCode(originalRequest, maxRetries); // Retry
  }
}

export async function handling401ErrorCode(originalRequest) {
  originalRequest._retry = true;
  try {
    const newAccessToken = await refreshToken();
    originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
    return instance(originalRequest);
  } catch (refreshError) {
    return Promise.reject(refreshError);
  }
}
